import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeneralHistoryViewModel } from 'src/app/model/general/history.view';

@Component({
  selector: 'ms-history-item',
  templateUrl: './history-item.component.html',
})
export class HistoryItemComponent {
  @Input() history: GeneralHistoryViewModel = {};
  @Output() historyChange: EventEmitter<GeneralHistoryViewModel> =
    new EventEmitter();

  handleChange = (isChekbox: boolean = false) => {
    if (isChekbox) {
      delete this.history.details;
    }
    this.historyChange.emit(this.history);
  };

  handleLabelClick = () => {
    if (!this.history.historyId) {
      this.history.filled = !this.history.filled;
      this.handleChange(true);
    }
  };
}
